import { useSelector } from 'react-redux';
import { useFeatureFlag } from 'contexts/featureFlagContext';

import { RootState } from 'types';

export const useOnboardingSignIn = () => {
  const { isOnboardingServiceEnabled: isMaskedSignInMechanismEnabled } =
    useFeatureFlag();
  const isOnboardingServiceEnabled = useSelector(
    (state: RootState) =>
      isMaskedSignInMechanismEnabled &&
      !!state.authentication?.group_code &&
      !state.authentication?.isPostSubmissionLogin,
  );

  return isOnboardingServiceEnabled;
};
